import React, { Fragment , useEffect  } from 'react';
import { MediaQuery } from '../../../utils/responsive_utilities';
import HeaderDesktop from './HeaderDesktop/index';
import HeaderMobileTab from './HeaderMobileTab/index';

const Header = React.memo(({appDownloadCTA, abTestsDetails, isTutoring}) => {


  const setLandingPageUrl = () => {
      let landing_page_url_key = sessionStorage.getItem("landing_page_url");
      if (landing_page_url_key == null) {
        let landing_page_url = window.location.pathname.substring(1);
        if (landing_page_url === "") {
          landing_page_url = "/";
        }
        sessionStorage.setItem('landing_page_url', JSON.stringify([landing_page_url]));
      }
  }
  useEffect(() => {
      setLandingPageUrl();
  }, []);
  return (
    <Fragment>
      <MediaQuery query={`(min-width: 1280px)`}>
        <HeaderDesktop abTestsDetails={abTestsDetails} isTutoring={isTutoring}/>
      </MediaQuery>
      <MediaQuery query={`(max-width: 1279px)`}>
        <HeaderMobileTab appDownloadCTA={appDownloadCTA} abTestsDetails={abTestsDetails} isTutoring={isTutoring} />
      </MediaQuery>
    </Fragment>
  );
});
export default Header;
